/**
 * Commerce7 Collection Filter - clear filter handle
 */
const C7BaseUrl = "https://api.commerce7.com/v1";

// import { renderVivinoScore } from "./c7";

export default function C7Collection() {

	const selectors = {
        product: ".murrieta__c7-product",
        clubPricing: ".product-club-pricing",
        variant: ".c7-product__add-to-cart__price",
        loadMore: ".load-more",
        hiddenProduct: ".murrieta__c7-product.d-none",
        widgetWrapper: ".murrieta-c7-collection-widget",
        carousel: ".c7-product-collection__product-list"
	};

	this.init = () => {
        const target = document.getElementById("c7-content");

        if (target) {
            new MutationObserver((_, observer) => {
                const products = jQuery(selectors.product);
                if (products.length > 0) {
                    products.each( (index, product) => {
                        jQuery(product).find(selectors.variant).append(jQuery(product).find(selectors.clubPricing));
                        if (index >= 10) {
                            jQuery(product).addClass("d-none");
                        }
                    });
                    if (products.length > 10) {
                        jQuery(selectors.loadMore).removeClass("d-none");
                        jQuery(selectors.loadMore).on("click", () => {
                            loadMoreWines();
                        });
                    }
                    observer.disconnect();
                }
            }).observe(target, { childList: true, subtree: true });
        }

        const C7CollectionWidget = document.querySelector(selectors.widgetWrapper);

        if ( C7CollectionWidget ) {
            new MutationObserver((_, observer) => {
                const products = jQuery(selectors.product);
                if (products.length > 0) {
                    products.each( (index, product) => {
                        jQuery(product).find(selectors.variant).append(jQuery(product).find(selectors.clubPricing));
                    });
                    jQuery(selectors.carousel).addClass("owl-carousel");
                    jQuery(selectors.carousel).owlCarousel({
                        autoplay: true,
                        autoplayTimeout: 30000,
                        dots: false,
                        items: 1,
                        loop: true,
                        nav: true,
                        navText: [
                            '<img class="prev-arrow" src="/wp-content/themes/commerce7-child/assets/images/prev-arrow.png">',
                            '<img class="next-arrow" src="/wp-content/themes/commerce7-child/assets/images/next-arrow.png">',
                        ],
                        smartSpeed: 700,
                    });
                    observer.disconnect();
                }
            }).observe(C7CollectionWidget, { childList: true, subtree: true });
        }
    }

    const loadMoreWines = () => {
        const hiddenProducts = jQuery(selectors.hiddenProduct);
        if (hiddenProducts.length > 0) {
            hiddenProducts.each((index, product) => {
                if (index < 10) jQuery(product).removeClass("d-none")
            })
        }
        if (hiddenProducts.length <= 10)
        jQuery(selectors.loadMore).addClass("d-none");
    }
}